import { FeatureFlag, featureFlagsStore } from '~/modules/stores/feature_flags_store';

export const FeatureFlags = {
    get FF_UNIFIED_DOMAINS(): boolean {
        return withLocalStorageOverride('FF_UNIFIED_DOMAINS', isEnabled('ace-unified-domains'));
    },
    get FF_GA4_ANALYTICS(): boolean {
        return withLocalStorageOverride('FF_GA4_ANALYTICS', isEnabled('discovery-ga4-analytics'));
    },
    get FF_CUSTOMER_CONSOLE(): boolean {
        return withLocalStorageOverride('FF_CUSTOMER_CONSOLE', isEnabled('customer-console'));
    },
    get FF_FILTER_COPILOT_SOLUTONS(): boolean {
        return withLocalStorageOverride('FF_FILTER_COPILOT_SOLUTONS', isEnabled('ace-copilot-solutions'));
    },
    get FF_SALES_PROGRAM_FILTER(): boolean {
        return withLocalStorageOverride('FF_SALES_PROGRAM_FILTER', isEnabled('discovery-sales-programs-filter'));
    },
    get FF_MA_NEW_TRAFFIC_SOURCES(): boolean {
        return withLocalStorageOverride('FF_MA_NEW_TRAFFIC_SOURCES', isEnabled('discovery-ma-new-traffic-sources'));
    },
    get FF_JAPANESE_SITE_LEARN_TAB(): boolean {
        return withLocalStorageOverride('FF_JAPANESE_SITE_LEARN_TAB', isEnabled('discovery-learn-tab-jp'));
    },
    get FF_AGENTFORCE_CHAT_BUTTON(): boolean {
        // Local storage override is intentionally avoided here because
        // this feature flag should always be controlled by remote configuration.
        return isEnabled('discovery-agentforce');
    },
    get FF_EXPLORE_AGENTFORCE_PAGE(): boolean {
        return withLocalStorageOverride('FF_EXPLORE_AGENTFORCE_PAGE', isEnabled('discovery-explore-page-agentforce'));
    },
    get FF_DISABLE_AUTO_LOAD_QUALIFIED_CHAT(): boolean {
        return withLocalStorageOverride(
            'FF_DISABLE_AUTO_LOAD_QUALIFIED_CHAT',
            isEnabled('discovery-disable-auto-load-qualified-chat'),
        );
    },
    get FF_USE_HYBRID_SEARCH_ENGINE(): boolean {
        return withLocalStorageOverride('FF_USE_HYBRID_SEARCH_ENGINE', isEnabled('use-hybrid-search-engine'));
    },
    get FF_DATA_CLOUD_SEARCH_UI(): boolean {
        return withLocalStorageOverride('FF_DATA_CLOUD_SEARCH_UI', isEnabled('discovery-ui-data-cloud-search'));
    },
    get FF_ACE_MCP_SERVERS(): boolean {
        return withLocalStorageOverride('FF_ACE_MCP_SERVERS', isEnabled('ace-mcp-servers'));
    },
    get FF_ACE_ANALYTICS_EVENTS_PUSH_TO_DATA_CLOUD(): boolean {
        return withLocalStorageOverride(
            'FF_ACE_ANALYTICS_EVENTS_PUSH_TO_DATA_CLOUD',
            isEnabled('ace-analytics_events-push_to_data_cloud'),
        );
    },
    get FF_ACE_ENABLE_DC_V3(): boolean {
        return withLocalStorageOverride('FF_ACE_ENABLE_DC_V3', isEnabled('ace-enable-dc-v3'));
    },
    get FF_PARTNER_W9_COLLECTION(): boolean {
        return withLocalStorageOverride('FF_PARTNER_W9_COLLECTION', isEnabled('partner-w9-site-ui'));
    },
    get FF_ACE_ENABLE_AGENTIC_SEARCH(): boolean {
        return withLocalStorageOverride('FF_ACE_ENABLE_AGENTIC_SEARCH', isEnabled('ace-enable-agentic-search'));
    },
    get FF_AGENTEXCHANGE_REBRAND(): boolean {
        return withLocalStorageOverride('FF_AGENTEXCHANGE_REBRAND', isEnabled('agentexchange-rebrand'));
    },
    get FF_ACE_AUTOCOMPLETE_SUGGESTION(): boolean {
        return withLocalStorageOverride('FF_ACE_AUTOCOMPLETE_SUGGESTION', isEnabled('ace-autocomplete-suggestion'));
    },
    get FF_ACE_INLINE_SUGGESTION(): boolean {
        return withLocalStorageOverride('FF_ACE_INLINE_SUGGESTION', isEnabled('ace-inline-suggestion'));
    },
    get FF_PARTNER_FINDER_ACTIVATE_IFRAME_EN(): boolean {
        return withLocalStorageOverride(
            'FF_PARTNER_FINDER_ACTIVATE_IFRAME_EN',
            isEnabled('partner-finder-activate-iframe-en'),
        );
    },
    get FF_PARTNER_FINDER_ACTIVATE_IFRAME_JP(): boolean {
        return withLocalStorageOverride(
            'FF_PARTNER_FINDER_ACTIVATE_IFRAME_JP',
            isEnabled('partner-finder-activate-iframe-jp'),
        );
    },
    get FF_SLACK_BANNER(): boolean {
        return withLocalStorageOverride('FF_SLACK_BANNER', isEnabled('ace-slack-banner'));
    },
    get FF_TOP_SEARCHES(): boolean {
        return withLocalStorageOverride('FF_TOP_SEARCHES', isEnabled('ace-top-searches'));
    },
    get FF_TRYBUY_REQUEST_PRIVATE_OFFER(): boolean {
        return withLocalStorageOverride(
            'FF_TRYBUY_REQUEST_PRIVATE_OFFER',
            isEnabled('trybuy-request-private-offer-site-ui'),
        );
    },
    get FF_ACE_ENABLE_FRONTEND_TRIE(): boolean {
        return withLocalStorageOverride('FF_ACE_ENABLE_FRONTEND_TRIE', isEnabled('ace-enable-frontend-trie'));
    },
    get FF_SHARED_AGENTFORCE_REBRANDING(): boolean {
        return withLocalStorageOverride('FF_SHARED_AGENTFORCE_REBRANDING', isEnabled('shared-agentforce-rebranding'));
    },
    get FF_ACE_ENABLE_AI_LISTINGS_SUMMARY(): boolean {
        return withLocalStorageOverride(
            'FF_ACE_ENABLE_AI_LISTINGS_SUMMARY',
            isEnabled('ace-enable-AI-listings-summary'),
        );
    },
    get FF_ACE_SUGGESTION_COMPRESSION(): boolean {
        return withLocalStorageOverride('FF_ACE_SUGGESTION_COMPRESSION', isEnabled('ace-suggestion-compression'));
    },
    get FF_TRYBUY_CONSULTANT_MODERN_SITE_UI(): boolean {
        return withLocalStorageOverride(
            'FF_TRYBUY_CONSULTANT_MODERN_SITE_UI',
            isEnabled('trybuy-consultant-modern-site-ui'),
        );
    },
    get FF_TRYBUY_TRUST_CENTER(): boolean {
        return withLocalStorageOverride('FF_TRYBUY_TRUST_CENTER', isEnabled('trybuy-trust-center-site-ui'));
    },
    get FF_CODEBASE_MERGER(): boolean {
        return withLocalStorageOverride('FF_CODEBASE_MERGER', isEnabled('ff-codebase-merger'));
    },
    get FF_CONSISTENT_FILTERS(): boolean {
        return withLocalStorageOverride('FF_CONSISTENT_FILTERS', isEnabled('ff-consistent-filters'));
    },
    get FF_AGENTEXCHANGE_REBRAND_JP(): boolean {
        return withLocalStorageOverride('FF_AGENTEXCHANGE_REBRAND_JP', isEnabled('agentexchange-rebrand-jp'));
    },
    get FF_ORG_PICKER(): boolean {
        return withLocalStorageOverride('FF_ORG_PICKER', isEnabled('ff-org-picker'));
    },
    get FF_ORG_PICKER_PERSONALIZATION(): boolean {
        return withLocalStorageOverride('FF_ORG_PICKER_PERSONALIZATION', isEnabled('ff-org-picker-personalization'));
    },
    get FF_SLACK_MARKETPLACE_INTEGRATION(): boolean {
        return withLocalStorageOverride(
            'FF_SLACK_MARKETPLACE_INTEGRATION',
            isEnabled('ff-slack-marketplace-integration'),
        );
    },
    get FF_SHOW_TABLEAU_NEXT_ON_SITE_UI(): boolean {
        return withLocalStorageOverride('FF_SHOW_TABLEAU_NEXT_ON_SITE_UI', isEnabled('show-tableau-next-on-site-ui'));
    },
    get FF_IIS_JS_V2(): boolean {
        return withLocalStorageOverride('FF_IIS_JS_V2', isEnabled('ace-iis-js-v2'));
    },
};

function isEnabled(featureFlag: FeatureFlag, defaultValue = false) {
    return featureFlagsStore.getState().featureFlags[featureFlag] ?? defaultValue;
}

function withLocalStorageOverride(featureFlagName: string, defaultValue = false) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const override = globalThis.localStorage?.getItem(featureFlagName) ?? null;
    if (override == null) {
        return defaultValue;
    }
    return override === 'true';
}
